import { Paper, Typography } from '@mui/material/';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import Link from 'next/link';

export default function NotificationBanner({ notification }) {
  if (notification === null || notification === undefined) return null;
  const iconStyle = { color: 'white', fontSize: 24 };
  const iconSx = { m: '-4px 4px' };
  return (
    <Paper elevation={1} sx={{ p: '24px', height: '100%', width: '100%', margin: '8px', padding: '8px' }}>
      <Alert
        iconMapping={{
          success: (
            <Paper sx={{ maxHeight: '30px', backgroundColor: '#008024' }}>
              <CheckCircleOutlinedIcon style={iconStyle} sx={iconSx} fontSize="inherit" />
            </Paper>
          ),
          info: (
            <Paper sx={{ maxHeight: '30px', backgroundColor: '#024DBC' }}>
              <InfoOutlinedIcon style={iconStyle} sx={iconSx} fontSize="inherit" />
            </Paper>
          ),
          warning: (
            <Paper sx={{ maxHeight: '30px', backgroundColor: '#FD7E14' }}>
              <WarningAmberOutlinedIcon style={iconStyle} sx={iconSx} fontSize="inherit" />
            </Paper>
          ),
        }}
        severity={notification.severity}
        sx={{ backgroundColor: 'white' }}
      >
        <Typography sx={{ mt: '5px', fontWeight: 400 }}>
          {notification.message}
          {notification.appendSettingsLink === true ? (
            <Link className="greenLink" href="/stillingar">
              Stillingar.
            </Link>
          ) : (
            ''
          )}
        </Typography>
      </Alert>
    </Paper>
  );
}
NotificationBanner.propTypes = {
  notification: PropTypes.shape({
    severity: PropTypes.oneOf(['info', 'warning', 'success']).isRequired,
    message: PropTypes.string.isRequired,
    appendSettingsLink: PropTypes.bool,
  }),
};
